<template>
  <InputPopover
    ref="popover"
    v-bind="{ modelValue, icon, borderless, outlined, dense, error, errorMessage, label, placeholder, useInput, clearable, autofocus, separator, multiple, disable, hideSelected, display, valueDebounce, showSelection, hideOnFirstClick, inputClass }"
    :placeholder="placeholder"
    :loading="false"
    :results="[]"
    :search="() => {}"
    behavior="menu"
    option-label=""
    @focus="onFocusInputEle"
  >
    <template #selected-item="scope">
      <appointment-item
        v-if="scope.item && typeof scope.item === 'object' && !Array.isArray(scope.item)"
        :appointment="scope.item"
        :disable="disable"
        clickable
        prevent-side-click
        @click="viewingAppointmentID = scope.item.id"
      >
        <template v-if="!disable" #default>
          <cancel-button @click="removeModelAtIndex(scope.index)" />
        </template>
      </appointment-item>
    </template>
  </InputPopover>
  <AppointmentViewDialog
    :id="viewingAppointmentID"
    allow-editing
    :with-quick-links="false"
    @close="viewingAppointmentID = null"
  />
  <appointment-select-dialog
    ref="selectDialog"
    :model-value="modelValue"
    :show-selection="showSelection"
    :multiple="multiple"
    :is-scheduled="isScheduled"
    :restrict-to-clients="filterClients"
    :restrict-to-attendees="filterUsers"
    :can-create="canCreate"
    @update:model-value="onInput"
    @clicked-result="onClickedResult"
    @removed-result="onRemovedResult"
  />
</template>
<script>
import InputPopover from 'components/partials/search/inputPopover/InputPopover'
import AppointmentViewDialog from './view/Dialog'
import inputPopoverMixin from 'components/partials/search/inputPopover/inputPopoverMixin'
export default {
  components: {
    InputPopover, AppointmentViewDialog
  },
  mixins: [inputPopoverMixin],
  props: {
    modelValue: {
      type: [Array, Object],
      default () {
        return []
      }
    },
    canCreate: {
      type: Boolean,
      default: false
    },
    isScheduled: {
      type: Boolean,
      default: false
    },
    filterUsers: {
      type: Array,
      default () {
        return []
      }
    },
    filterClients: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      viewingAppointmentID: null
    }
  },
  methods: {
    onFocusInputEle () {
      this.timed(() => {
        this.$refs.popover.blur()
        this.timed(() => {
          this.$refs.selectDialog.open()
        })
      })
    }
  }
}
</script>
